import { NgxMatDatetimePickerModule } from '@angular-material-components/datetime-picker';
import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PlotlyModule } from 'angular-plotly.js';
import { ResizableModule } from 'angular-resizable-element';
import { AngularSplitModule } from 'angular-split';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import * as PlotlyJS from 'plotly.js/dist/plotly.js';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { MenuModule } from 'primeng/menu';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SliderModule } from 'primeng/slider';
import { TableModule } from 'primeng/table';
import { InputDialogComponent } from 'src/app/common/dialog/input-dialog/input-dialog.component';
import { ConfirmationDialogComponent } from '../common/dialog/confirmation/confirmation-dialog.component';
import { DialogService } from '../common/dialog/dialog.service';
import { ImageViewerDialogComponent } from '../common/dialog/image-viewer-dialog/image-viewer-dialog.component';
import { InfoDialogComponent } from '../common/dialog/info-dialog/info-dialog.component';
import { LoadingDialogComponent } from '../common/dialog/loading-dialog/loading-dialog.component';
import { OptionsDialogComponent } from '../common/dialog/options/options-dialog.component';
import { TextConfirmationComponent } from '../common/dialog/text-confirmation/text-confirmation.component';
import { UserFileService } from '../files/service/user-file.service';
import { VehicleFacadeService } from '../management/service/vehicle-facade.service';
import { VehicleService } from '../management/service/vehicle.service';
import { MaterialModule } from '../material.module';
import { PeopleCountersChartDataPreparatorService } from '../reports/service/people-counters-chart-data-preparator.service';
import { BusStopTreeItemComponent } from '../vehicles/component/bus-stop/bus-stop-tree-item/bus-stop-tree-item.component';
import { VehicleGroupDialogComponent } from '../vehicles/component/vehicle-group-dialog/vehicle-group-dialog.component';
import { FrameTreeItemComponent } from '../vehicles/component/vehicle/frame-tree-item/frame-tree-item.component';
import { VehicleGroupsProvider } from '../vehicles/service/vehicle-group-provider.service';
import { VehicleGroupService } from '../vehicles/service/vehicle-group.service';
import { AutocompleteFormComponent } from './component/autocomplete-form/autocomplete-form.component';
import { ButtonMenuComponent } from './component/button-menu/button-menu.component';
import { ChartViewComponent } from './component/chart-view/chart-view.component';
import { ColorPickerComponent } from './component/color-picker/color-picker.component';
import { ColumnHiderListComponent } from './component/column-options/column-hider-list/column-hider-list.component';
import { GroupingColumnSelectorComponent } from './component/column-options/grouping-column-selector/grouping-column-selector.component';
import { SummarySelectorComponent } from './component/column-options/summary-selector/summary-selector.component';
import { CronGeneratorComponent } from './component/cron-generator/cron-generator.component';
import { DataOptionsComponent } from './component/data-options/data-options.component';
import { DateSelectorComponent } from './component/date-selector/date-selector.component';
import { ChartDialogComponent } from './component/dialog/chart-dialog/chart-dialog.component';
import { ChooseVehicleDialogComponent } from './component/dialog/choose-vehicle-dialog/choose-vehicle-dialog.component';
import { ColumnSettingsDialogComponent } from './component/dialog/column-settings-dialog/column-settings-dialog.component';
import { FetchProgressDialogComponent } from './component/dialog/fetch-progress-dialog/fetch-progress-dialog.component';
import { ContextMenuComponent } from './component/context-menu/context-menu.component';
import { ContextSubmenuComponent } from './component/context-menu/context-submenu.component';
import { ExportDataComponent } from './component/dialog/export-data/export-data-component';
import { ReportFilenameEditorComponent } from './component/dialog/export-data/report-filename-editor/report-filename-editor.component';
import { LabelFieldsSelectorDialogComponent } from './component/dialog/label-fields-selector-dialog/label-fields-selector-dialog.component';
import { SummarySettingsDialogComponent } from './component/dialog/summary-settings-dialog/summary-settings-dialog.component';
import { TextEditorDialogComponent } from './component/dialog/text-editor-dialog/text-editor-dialog.component';
import { ExpandableTreeComponent } from './component/expandable-tree/expandable-tree.component';
import { ExportViewComponent } from './component/export-view/export-view.component';
import { FilePlayerComponent } from './component/file-player/file-player.component';
import { PlayerComponent } from './component/file-player/player/player.component';
import { TextContentComponent } from './component/file-player/text-content/text-content.component';
import { VideoControlDirective } from './component/file-player/video-control.directive';
import { FiltersViewComponent } from './component/filters-view/filters-view.component';
import { FloatingDialogComponent } from './component/floating-dialog/floating-dialog.component';
import { FloatingDialogService } from './service/floating-dialog/floating-dialog.service';
import { FormEditorComponent } from './component/form-editor/form-editor.component';
import { MatErrorMessagesDirective } from './component/form-editor/mat-error-messages.directive';
import { IconComponent } from './component/icon/icon.component';
import { MultiselectFilterFormComponent } from './component/multiselect-filter-form/multiselect-filter-form.component';
import { OptionCheckListComponent } from './component/option-check-list/option-check-list.component';
import { PassengersCountComponent } from './component/passengers-count/passengers-count.component';
import { ClearFilterComponent } from './component/prime-table/parts/column-filter/clear-filter/clear-filter.component';
import { ColumnFilterComponent } from './component/prime-table/parts/column-filter/column-filter.component';
import { ColumnFilterValueComponent } from './component/prime-table/parts/column-filter/filter-value/filter-value.component';
import { ContentRowColumnsComponent } from './component/prime-table/parts/content-row-columns/content-row-columns.component';
import { DisplayJsonComponent } from './component/prime-table/parts/display-json/display-json.component';
import { FillBarComponent } from './component/prime-table/parts/fill-bar/fill-bar.component';
import { RowIconMenuComponent } from './component/prime-table/parts/row-icon-menu/row-icon-menu.component';
import { SummaryComponent } from './component/prime-table/parts/summary/summary.component';
import { ViolationsMarkerComponent } from './component/prime-table/parts/violations-marker/violations-marker.component';
import { ViolationsMarker2Component } from './component/prime-table/parts/violations-marker/violations-marker2.component';
import { MinimapDirective } from './component/prime-table/controllers/minimap.directive';
import { RowRulerDirective } from './component/prime-table/controllers/row-ruler.directive';
import { PrimeTableComponent } from './component/prime-table/prime-table.component';
import { SelectCheckAllComponent } from './component/select-check-all/select-check-all.component';
import { SelectWithDeleteOptionComponent } from './component/select-with-delete-option/select-with-delete-option.component';
import { CarrierSelectorComponent } from './component/selectors/carrier-selector/carrier-selector.component';
import { DateRangeSelectorComponent } from './component/selectors/date-range-selector/date-range-selector/date-range-selector.component';
import { SidenavToggleComponent } from './component/sidenav-toggle/sidenav-toggle.component';
import { SimpleIconButtonMenuComponent } from './component/simple-icon-button-menu/simple-icon-button-menu.component';
import { SliderPickerComponent } from './component/slider-picker/slider-picker.component';
import { TreeItemComponent } from './component/tree-item/tree-item.component';
import { UploadComponent } from './component/upload/upload.component';
import { UsageHintComponent } from './component/usage-hint/usage-hint.component';
import { DeviceFilterComponent } from './component/vehicle-layout-view/device-filter/device-filter.component';
import { VehicleLayoutViewComponent } from './component/vehicle-layout-view/vehicle-layout-view.component';
import { ViolationTooltipComponent } from './component/violation-tooltip/violation-tooltip.component';
import { DatePickerAutoConfirmDirective } from './directive/date-picker-auto-confirm.directive';
import { IsAtBottomDirective } from './directive/is-at-bottom';
import { OverlayScrollbarDirective } from './directive/overlay-scrollbar.directive';
import { PanelTriggerDirective } from './directive/panel-trigger.directive';
import { ResizeObserverDirective } from './directive/resize-observer.directive';
import { TabsWheelScrollDirective } from './directive/tabs-wheel-scroll.directive';
import { ViolationTooltipDirective } from './directive/violation-tooltip.directive';
import { FiltersDialogComponent } from './filter/component/dialog/filters-dialog/filters-dialog.component';
import { SetOfFiltersDialogComponent } from './filter/component/dialog/set-of-filters-dialog/set-of-filters-dialog.component';
import { FilterBuilderFieldSelectComponent } from './filter/component/filter-builder-field-select/filter-builder-field-select.component';
import { FilterBuilderListFieldComponent } from './filter/component/filter-builder-list-field/filter-builder-list-field.component';
import { FilterBuilderViolationWithStatusFieldComponent }
  from './filter/component/filter-builder-violation-with-status-field/filter-builder-violation-with-status-field.component';
import { FilterBuilderComponent } from './filter/component/filter-builder/filter-builder.component';
import { FilterHistoryComponent } from './filter/component/filter-history/filter-history.component';
import { SetOfFiltersComponent } from './filter/component/set-of-filters/set-of-filters.component';
import { FilterBuilderService } from './filter/service/filter-builder.service';
import { FilterDataProvider } from './filter/service/filter-data-provider';
import { FilterDataService } from './filter/service/filter-data-service';
import { FilterHistoryService } from './filter/service/filter-history.service';
import { SetsOfFiltersService } from './filter/service/sets-of-filters.service';
import { BytesHumanReadablePipe } from './pipe/bytes-human-readable.pipe';
import { CapitalizeFirstPipe } from './pipe/capitalize-first.pipe';
import { DictionaryTranslatePipe } from './pipe/dictionary-translate.pipe';
import { EnumToArrayPipe } from './pipe/enum-to-array.pipe';
import { ExtractAndTrimPipe } from './pipe/extract-and-trim.pipe';
import { FillPipe } from './pipe/fill.pipe';
import { HtmlFromTextPipe } from './pipe/html-from-text.pipe';
import { JoinPipe } from './pipe/join.pipe';
import { LocationTypePipe } from './pipe/location-type-pipe';
import { MinuteSecondsPipe } from './pipe/minute-seconds.pipe';
import { OrderByPipe } from './pipe/order-by.pipe';
import { RemoveCommaPipe } from './pipe/remove-comma.pipe';
import { SecondsToTimePipe } from './pipe/seconds-to-time.pipe';
import { SnakeCaseToCamelCasePipe } from './pipe/snake-case-to-camel-case.pipe';
import { StringDatePipe } from './pipe/string-date.pipe';
import { TimeDeviationPipe } from './pipe/time-deviation.pipe';
import { TranslateExtPipe } from './pipe/translate-ext.pipe';
import { TruncatePipe } from './pipe/truncate.pipe';
import { ColumnFilterService } from './service/column-filter.service';
import { SnackBarService } from './service/snackbar.service';
import { TableColumnsService } from './service/table-columns.service';
import { GroupingColumnListComponent } from './component/grouping-column-list/grouping-column-list.component';
import { PaginatorModule } from 'primeng/paginator';
import { StpVehiclesSelectorComponent } from './component/selectors/stp-vehicle-selector/multi/stp-vehicles-selector.component';
import { StpZoneSelectorComponent } from './component/selectors/stp-zone-selector/stp-zone-selector.component';
import { StpVehicleSelectorComponent } from './component/selectors/stp-vehicle-selector/single/stp-vehicle-selector.component';
import { MultiSelectModule } from 'primeng/multiselect';
PlotlyModule.plotlyjs = PlotlyJS;

@NgModule({
  declarations: [
    ExpandableTreeComponent,
    FilterBuilderComponent,
    FiltersViewComponent,
    FiltersDialogComponent,
    TreeItemComponent,
    FrameTreeItemComponent,
    BusStopTreeItemComponent,
    ColumnSettingsDialogComponent,
    FetchProgressDialogComponent,
    ContextMenuComponent,
    ContextSubmenuComponent,
    SidenavToggleComponent,
    ChartDialogComponent,
    ChartViewComponent,
    DataOptionsComponent,
    ConfirmationDialogComponent,
    OptionsDialogComponent,
    InfoDialogComponent,
    LoadingDialogComponent,
    SelectCheckAllComponent,
    PrimeTableComponent,
    MinimapDirective,
    RowRulerDirective,
    PanelTriggerDirective,
    ExportViewComponent,
    IconComponent,
    FormEditorComponent,
    SetOfFiltersDialogComponent,
    SelectWithDeleteOptionComponent,
    SetOfFiltersComponent,
    InputDialogComponent,
    ButtonMenuComponent,
    FilterBuilderListFieldComponent,
    FilterBuilderViolationWithStatusFieldComponent,
    FilterBuilderFieldSelectComponent,
    ColumnHiderListComponent,
    GroupingColumnSelectorComponent,
    ContentRowColumnsComponent,
    LabelFieldsSelectorDialogComponent,
    UsageHintComponent,
    UploadComponent,
    PassengersCountComponent,
    TimeDeviationPipe,
    LocationTypePipe,
    StringDatePipe,
    JoinPipe,
    ExtractAndTrimPipe,
    TranslateExtPipe,
    ExtractAndTrimPipe,
    TruncatePipe,
    MinuteSecondsPipe,
    EnumToArrayPipe,
    SnakeCaseToCamelCasePipe,
    OrderByPipe,

    MatErrorMessagesDirective,
    VehicleLayoutViewComponent,
    DeviceFilterComponent,
    SummaryComponent,
    SummarySettingsDialogComponent,
    RemoveCommaPipe,
    SummarySelectorComponent,
    RowIconMenuComponent,
    FillBarComponent,
    FillPipe,
    SummarySelectorComponent,
    BytesHumanReadablePipe,
    ColumnFilterComponent,
    ColumnFilterValueComponent,
    ClearFilterComponent,
    ViolationsMarkerComponent,
    ViolationsMarker2Component,
    TextEditorDialogComponent,
    ChooseVehicleDialogComponent,
    FilePlayerComponent,
    SimpleIconButtonMenuComponent,
    PlayerComponent,
    VideoControlDirective,
    SecondsToTimePipe,
    HtmlFromTextPipe,
    TextContentComponent,
    ColorPickerComponent,
    SliderPickerComponent,
    ChooseVehicleDialogComponent,
    DisplayJsonComponent,
    ResizeObserverDirective,
    IsAtBottomDirective,
    OverlayScrollbarDirective,
    TabsWheelScrollDirective,
    DatePickerAutoConfirmDirective,
    CronGeneratorComponent,
    ExportDataComponent,
    ImageViewerDialogComponent,
    AutocompleteFormComponent,
    DictionaryTranslatePipe,
    PassengersCountComponent,
    ReportFilenameEditorComponent,
    CapitalizeFirstPipe,
    TextConfirmationComponent,
    VehicleGroupDialogComponent,
    DateSelectorComponent,
    ViolationTooltipDirective,
    ViolationTooltipComponent,
    FloatingDialogComponent,
    MultiselectFilterFormComponent,
    OptionCheckListComponent,
    FilterHistoryComponent,
    CarrierSelectorComponent,
    DateRangeSelectorComponent,
    GroupingColumnListComponent,
    StpVehiclesSelectorComponent,
    StpVehicleSelectorComponent,
    StpZoneSelectorComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FlexLayoutModule,
    MaterialModule,
    TranslateModule.forChild({
      extend: true
    }),
    FormsModule,
    ReactiveFormsModule,
    NgxMatDatetimePickerModule,
    PlotlyModule,
    ResizableModule,
    TableModule,
    MenuModule,
    MatAutocompleteModule,
    AngularSplitModule,
    DragDropModule,
    PortalModule,
    OverlayModule,
    A11yModule,
    ProgressBarModule,
    ColorPickerModule,
    SliderModule,
    NgxJsonViewerModule,
    OverlayPanelModule,
    CalendarModule,
    DialogModule,
    InputNumberModule,
    ButtonModule,
    BadgeModule,
    ProgressSpinnerModule,
    MatIconModule,
    PaginatorModule,
    MultiSelectModule
  ],
  exports: [
    MultiSelectModule,
    InputNumberModule,
    FlexLayoutModule,
    TranslateModule,
    MaterialModule,
    NgxMatDatetimePickerModule,
    ExpandableTreeComponent,
    SidenavToggleComponent,
    DataOptionsComponent,
    SelectCheckAllComponent,
    PrimeTableComponent,
    ExportViewComponent,
    IconComponent,
    FormEditorComponent,
    ButtonMenuComponent,
    UsageHintComponent,
    TimeDeviationPipe,
    LocationTypePipe,
    JoinPipe,
    ExtractAndTrimPipe,
    TruncatePipe,
    MinuteSecondsPipe,
    EnumToArrayPipe,
    TranslateExtPipe,
    VehicleLayoutViewComponent,
    DeviceFilterComponent,
    SummaryComponent,
    AngularSplitModule,
    DragDropModule,
    FillBarComponent,
    BytesHumanReadablePipe,
    FilePlayerComponent,
    SecondsToTimePipe,
    TableModule,
    ColorPickerComponent,
    SliderPickerComponent,
    NgxJsonViewerModule,
    ResizeObserverDirective,
    OverlayScrollbarDirective,
    TabsWheelScrollDirective,
    DatePickerAutoConfirmDirective,
    CronGeneratorComponent,
    DictionaryTranslatePipe,
    PassengersCountComponent,
    ReportFilenameEditorComponent,
    StringDatePipe,
    OrderByPipe,
    CapitalizeFirstPipe,
    OverlayPanelModule,
    DateSelectorComponent,
    IsAtBottomDirective,
    FloatingDialogComponent,
    AutocompleteFormComponent,
    MultiselectFilterFormComponent,
    OptionCheckListComponent,
    PanelTriggerDirective,
    ButtonModule,
    CarrierSelectorComponent,
    DateRangeSelectorComponent,
    MatIconModule,
    GroupingColumnListComponent,
    PaginatorModule,
    StpZoneSelectorComponent,
    StpVehiclesSelectorComponent,
    StpVehicleSelectorComponent,
    // Wystawione, bo menu kontekstowe stawia też mapa Pojazdów we własnym szablonie.
    ContextMenuComponent
  ],
  providers: [
    TimeDeviationPipe,
    LocationTypePipe,

    FloatingDialogService,
    SnackBarService,
    PeopleCountersChartDataPreparatorService,
    DialogService,
    TableColumnsService,
    SetsOfFiltersService,
    FilterBuilderService,
    FilterDataService,
    VehicleGroupService,
    VehicleService,
    VehicleGroupsProvider,
    VehicleFacadeService,

    FilterDataProvider,
    ColumnFilterService,
    FilterDataProvider,
    UserFileService,
    FilterHistoryService
  ]
})
export class SharedModule { }
